import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function OptOut() {
  return (
    <>
      <Helmet>
        <title>Opt-Out - Aramco Leads Pro</title>
        <meta name="description" content="Opt-out of messages from Aramco Leads Pro. Learn how to unsubscribe from SMS and email communications." />
      </Helmet>

      <div style={{ background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)', color: 'white', padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>Opt-Out Information</h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.95 }}>How to unsubscribe from messages</p>
        </div>
      </div>

      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '4rem 2rem' }}>
        <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
          
          <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>SMS Opt-Out</h2>
          <p style={{ marginBottom: '1rem', lineHeight: '1.8' }}>
            To stop receiving SMS messages, reply with any of these keywords:
          </p>
          <div style={{ background: '#dbeafe', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem' }}>
            <p style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1e40af', textAlign: 'center' }}>
              STOP | UNSUBSCRIBE | CANCEL | QUIT
            </p>
          </div>
          <p style={{ marginBottom: '2rem', lineHeight: '1.8' }}>
            You will immediately stop receiving messages and receive a confirmation.
          </p>

          <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>Email Opt-Out</h2>
          <p style={{ marginBottom: '2rem', lineHeight: '1.8' }}>
            To unsubscribe from emails, click the "Unsubscribe" link at the bottom of any email you receive from us.
          </p>

          <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>Need Help?</h2>
          <p style={{ marginBottom: '1rem', lineHeight: '1.8' }}>
            If you need assistance with opt-out, contact us:
          </p>
          <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px' }}>
            <p><strong>Email:</strong> support@aramcoleadspro.com</p>
            <p><strong>Phone:</strong> Available during business hours</p>
          </div>
        </div>
      </div>
    </>
  );
}
